import React, { Fragment } from 'react'
// TODO:
// import { FormattedMessage } from '@dragonraider5/react-intl'
import { SectionWrapper, SectionTitle } from '../../../../components/Section'

function ProjectWelcome() {
  return (
    <Fragment>
      <SectionTitle data-section='2'>
        Sobre el proyecto que quieres financiar
      </SectionTitle>
      <SectionWrapper>
        <p>Triodos Bank financia empresas, organizaciones e inciativas que aportan un valor añadido de carácter social, medioambiental y/o cultural. Ante toda solicitud de financiación, en primer lugar realizamos un análisis cualitativo para valorar la coherencia de la actividad con la política de financiación del banco. En segundo lugar, se lleva a cabo el análisis de riesgos habitual en las entidades de crédito. Para realizar una primera valoración de tu solicitud de financiación necesitamos una breve descripción de tu proyecto o actividad.</p>
      </SectionWrapper>
    </Fragment>
  )
}

export default ProjectWelcome
